import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=628a5180&scoped=true&"
import script from "./PanelHeader.vue?vue&type=script&lang=js&"
export * from "./PanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=628a5180&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a5180",
  null
  
)

export default component.exports